import { Footer } from "../../components/Footer";
import { HamburgerMenu } from "../../components/HamburgerMenu";
import { MyProfile } from "../../components/MyProfile";
import { Menu } from "../../components/Menu";

export const MenuPage = ({ isMenuOpen, setIsMenuOpen }) => {
    const { name } = JSON.parse(localStorage.getItem('PROFILE_DATA_SISCOPE') ?? `{"name":"Hunter Souza"}"`);

    return (
        <>
            <div style={{ padding: "1rem" }}>
                <HamburgerMenu onClick={() => setIsMenuOpen(!isMenuOpen)} />
                <MyProfile name={name} />
            </div>
            <Menu />

        </>
    )
}
